import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectFacilityId } from 'src/store/configSlice';
import { useGetAllFeaturesQuery } from 'src/store/sageAdminApi';

export const CommuniCareResolutionFlowFeatureId = 'ri.model.0.feature.communicare-resolution-flow';
const TaskingRemindersFeatureId = 'ri.model.0.feature.tasking-reminders';
export const DisableAlertButtonsFeatureId = 'ri.model.0.feature.disable-alert-buttons';
const StaffAnnouncementsFeatureId = 'ri.model.0.feature.staff-announcements';
export const ResidentCareInfoFeatureId = 'ri.model.0.feature.resident-care-info';

function useFacilityFeatures() {
    const facilityId = useSelector(selectFacilityId);

    const { data: facilityFeatures, ...rest } = useGetAllFeaturesQuery(
        { facilityId },
        { skip: !facilityId }
    );

    const featureIdSet = useMemo(
        () => new Set(facilityFeatures?.features?.map((f) => f.id)),
        [facilityFeatures]
    );

    return {
        ...rest,
        featureIdSet,
        features: facilityFeatures?.features,
        hasAlertButtonsDisabled: featureIdSet.has(DisableAlertButtonsFeatureId),
        isUsingCommuniCareResolutionFlow: featureIdSet.has(CommuniCareResolutionFlowFeatureId),
        isUsingTaskingReminders: featureIdSet.has(TaskingRemindersFeatureId),
        hasStaffAnnouncements: featureIdSet.has(StaffAnnouncementsFeatureId),
        hasResidentCareInfo: featureIdSet.has(ResidentCareInfoFeatureId),
    };
}

export default useFacilityFeatures;
